import type { AttestationDTO, DemandeRemboursementDTO, FraisDTO } from '@/features/api/extranet/dto/Demande/DR'
import type { PropertyStatusConfiguration } from '@/features/domaine/property-status/PropertyStatusConfiguration'
import { PropertyStatus } from '../../property-status'
import type { ContextReglesDR } from './types'

function quandModuleTraité(truePropertyStatus: PropertyStatus, falsePropertyStatus?: PropertyStatus) {
  return (_value: any, _index: number, parent: FraisDTO | AttestationDTO, model: DemandeRemboursementDTO) => {
    // Recherche du module
    const module = model.modules!.find((m) => m.idModule === parent.idModule)
    if (module === undefined) throw new Error('Invalid parent', { cause: { parent, model } })

    if (module.estTraite) return truePropertyStatus
    else return falsePropertyStatus ?? PropertyStatus.Optional
  }
}

export const propertyStatusConfiguration: PropertyStatusConfiguration<DemandeRemboursementDTO, ContextReglesDR> = {
  frais: {
    tauxTva: PropertyStatus.Required,
    montantDemandeRemboursement: quandModuleTraité(PropertyStatus.Optional, PropertyStatus.NotPresent),
  },
  attestations: {
    dateDebut: quandModuleTraité(PropertyStatus.Required, PropertyStatus.NotPresent),
    dateFin: quandModuleTraité(PropertyStatus.Required, PropertyStatus.NotPresent),
    duree: quandModuleTraité(PropertyStatus.Required, PropertyStatus.NotPresent),
  },
  consentementTraitementDonnees: PropertyStatus.Required,
  acceptationCg: PropertyStatus.Required,
  attestationSurHonneur: PropertyStatus.Required,
  lieuSignature: PropertyStatus.Required,
  mission: {
    avecMission: (_value, _parent, model) => {
      if (!['CDPI', 'CIPI'].includes(model.sousDispositif)) return PropertyStatus.NotPresent
      return PropertyStatus.Required
    },
    dateDebut: (_value, parent, model) => {
      if (!['CDPI', 'CIPI'].includes(model.sousDispositif)) return PropertyStatus.NotPresent
      return parent.avecMission === true ? PropertyStatus.Required : PropertyStatus.NotPresent
    },
    dateFin: (_value, parent, model) => {
      if (!['CDPI', 'CIPI'].includes(model.sousDispositif)) return PropertyStatus.NotPresent
      return parent.avecMission === true ? PropertyStatus.Required : PropertyStatus.NotPresent
    },
    duree: (_value, parent, model) => {
      if (!['CDPI', 'CIPI'].includes(model.sousDispositif)) return PropertyStatus.NotPresent
      return parent.avecMission === true ? PropertyStatus.Required : PropertyStatus.NotPresent
    },
    posteOccupe: (_value, parent, model) => {
      if (!['CDPI', 'CIPI'].includes(model.sousDispositif)) return PropertyStatus.NotPresent
      return parent.avecMission === true ? PropertyStatus.Required : PropertyStatus.NotPresent
    },
    avecTransport: (_value, parent, model) => {
      return ['CDPI'].includes(model.sousDispositif) && parent.avecMission === true
        ? PropertyStatus.Required
        : PropertyStatus.NotPresent
    },
    $model: (_, _parent, model) => {
      if (!['CDPI', 'CIPI'].includes(model.sousDispositif)) return PropertyStatus.NotPresent
      return PropertyStatus.Required
    },
  },
  commentaire: (_value, _parent, model) => {
    return model.mission?.avecMission === true ? PropertyStatus.NotPresent : PropertyStatus.Optional
  },
  dossier: {
    $model: PropertyStatus.NotPresent,
  },
  financement: {
    attestationResteChargeContribution: PropertyStatus.Required,
    modePriseEnChargeReste: (_, parent) =>
      parent.attestationResteChargeContribution === true ? PropertyStatus.Required : PropertyStatus.NotPresent,
  },
  reference: PropertyStatus.Required,
  attestationPiecesJustificatives: PropertyStatus.Required,
} as const
